var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType from '@wix/ambassador-payments-site-payment-method-types-v1-site-payment-method-type/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Format;
(function (Format) {
    Format["UNKNOWN_FORMAT"] = "UNKNOWN_FORMAT";
    Format["SVG"] = "SVG";
    Format["PNG"] = "PNG";
})(Format || (Format = {}));
const _buyerFlow = { icons: '_icon' };
const _getSitePaymentMethodTypeRequest = {};
const _getSitePaymentMethodTypeResponse = {
    sitePaymentMethodType: '_sitePaymentMethodType',
};
const _icon = { image: 'wix.common.Image' };
const _listSitePaymentMethodTypesRequest = {};
const _listSitePaymentMethodTypesResponse = {
    sitePaymentMethodTypes: '_sitePaymentMethodType',
};
const _merchantFlow = { icons: '_icon' };
const _sitePaymentMethodType = {
    merchantFlow: '_merchantFlow',
    buyerFlow: '_buyerFlow',
};
/**
 * Retrieves a SitePaymentMethodType.
 * @param sitePaymentMethodTypeId - SitePaymentMethodType ID
 * @internal
 * @documentationMaturity preview
 * @requiredField sitePaymentMethodTypeId
 * @adminMethod
 * @returns The requested SitePaymentMethodType.
 */
export function getSitePaymentMethodType(sitePaymentMethodTypeId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { sitePaymentMethodTypeId: '$[0]' };
        const responseTransformation = '$.sitePaymentMethodType';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getSitePaymentMethodTypeRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getSitePaymentMethodTypeResponse,
            depSchemas: { _buyerFlow, _icon, _merchantFlow, _sitePaymentMethodType },
            fqdnTransformation: {
                paths: [...['sitePaymentMethodType']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([sitePaymentMethodTypeId]);
        const reqOpts = ambassadorWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType.getSitePaymentMethodType(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'sitePaymentMethodTypeId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of SitePaymentMethodTypes. Never returns more than 200 records.
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function listSitePaymentMethodTypes(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { ids: '$[0].ids' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listSitePaymentMethodTypesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listSitePaymentMethodTypesResponse,
            depSchemas: { _buyerFlow, _icon, _merchantFlow, _sitePaymentMethodType },
            fqdnTransformation: {
                paths: [...['Array#sitePaymentMethodTypes']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType.listSitePaymentMethodTypes(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=payments-site-payment-method-types-v1-site-payment-method-type.universal.js.map